import React, { useState } from 'react';
import { X } from 'lucide-react';
import { createPortal } from 'react-dom';

interface ImageZoomProps {
  src: string;
  alt: string;
  className?: string;
}

export function ImageZoom({ src, alt, className = '' }: ImageZoomProps) {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleZoom = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent modal from closing
    setIsZoomed(true);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent modal from closing
    setIsZoomed(false);
  };

  return (
    <>
      <img
        src={src}
        alt={alt}
        onClick={handleZoom}
        className={`cursor-zoom-in transition-transform duration-300 hover:scale-[1.02] ${className}`}
      />

      {isZoomed && createPortal(
        <div 
          className="fixed inset-0 z-[999] bg-black/90 flex items-center justify-center p-4"
          onClick={handleClose}
        >
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200"
          >
            <X className="h-8 w-8" />
          </button>
          
          <img
            src={src}
            alt={alt}
            className="max-w-[95vw] max-h-[95vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>,
        document.body
      )}
    </>
  );
}